import React from "react"

interface Props {
  activeColor?: string
}

const IconFilter: React.FC<Props> = ({ activeColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M7.00039 14.8188C6.79508 14.8188 6.59306 14.7672 6.41289 14.6688C6.21285 14.563 6.04544 14.4047 5.9287 14.2109C5.81196 14.017 5.75031 13.795 5.75039 13.5688V8.7875L1.70664 4.34375C1.54279 4.16466 1.43464 3.94174 1.39537 3.70221C1.3561 3.46267 1.38743 3.21689 1.48552 2.99486C1.58361 2.77283 1.74422 2.58417 1.94775 2.4519C2.15127 2.31963 2.38891 2.24947 2.63164 2.25H13.3691C13.6119 2.24947 13.8495 2.31963 14.053 2.4519C14.2566 2.58417 14.4172 2.77283 14.5153 2.99486C14.6133 3.21689 14.6447 3.46267 14.6054 3.70221C14.5661 3.94174 14.458 4.16466 14.2941 4.34375L10.2504 8.7875V12.2313C10.2505 12.4375 10.1998 12.6406 10.1028 12.8227C10.0058 13.0047 9.86542 13.1601 9.69414 13.275L7.69414 14.6063C7.48835 14.7428 7.24734 14.8166 7.00039 14.8188ZM3.19414 3.75L6.92539 7.85C7.13627 8.08019 7.25236 8.38158 7.25039 8.69375V13.1L8.75039 12.1V8.69375C8.74842 8.38158 8.86451 8.08019 9.07539 7.85L12.8066 3.75H3.19414Z"
        fill={activeColor || "#EF7A00"}
      />
    </svg>
  )
}

export default IconFilter
